<template>
    <div class="introListWrap11">
        <el-row :gutter="10">
            <!--第一块-->
            <el-col :span="7">
                <div class="grid-content white firstBlock">
                    <div class=" blue1Bg heightBtn" style="box-sizing: border-box; padding:30px 0 0 50px;box-shadow: 0 3px 3px cornflowerblue;border-radius: 4px;">
                        <p><i class="el-icon-tickets biggestFont"></i></p>
                        <p class=" smallFont">累计成交总金额</p>
                        <p> <span class="biggestFont bold">{{numAll.totalAmount}}</span> <span class="normalFont">元</span></p>
                    </div>

                </div>
            </el-col>
            <!--第2块-->
            <el-col :span="7">
                <div class="grid-content white">
                    <div style="display: flex;margin-bottom: 10px;">
                        <div class="btnBox blue1Bg heightBtn_four" style="flex:1;margin-right: 10px;">
                            <i class="el-icon-tickets btnIcon normalFont"></i>
                            <div class="btnRight">
                                <p class="textLine"><span class="normal  Font bold">{{numAll.totalQuantity}}</span>
                                    <span class="smallFont">件</span> </p>
                                <p class="textLine smallFont">累计成交总件数</p>
                            </div>
                        </div>
                        <div class="btnBox blue1Bg heightBtn_four" style="flex:1">
                            <i class="el-icon-tickets btnIcon"></i>
                            <div class="btnRight">
                                <p class="textLine"><span class="normalFont bold">{{numAll.totalOrder}}</span>
                                    <span class="smallFont">笔</span> </p>
                                <p class="textLine smallFont">总下单数量</p>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;margin-bottom: 10px;">
                        <div class="btnBox blue2Bg heightBtn_four" style="flex:1;margin-right: 10px;">
                            <i class="el-icon-tickets btnIcon"></i>
                            <div class="btnRight">
                                <p class="textLine"><span class="normalFont bold">{{numAll.orderAmount}}</span>
                                    <span class="smallFont">元</span> </p>
                                <p class="textLine smallFont">累计订单总金额</p>
                            </div>
                        </div>
                        <div class="btnBox blue2Bg heightBtn_four" style="flex:1">
                            <i class="el-icon-tickets btnIcon"></i>
                            <div class="btnRight">
                                <p class="textLine"><span class="normalFont bold">{{numAll.orderQuantity}}</span>
                                    <span class="smallFont">件</span> </p>
                                <p class="textLine smallFont">累计订单总件数</p>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;margin-bottom: 10px;">
                        <div class="btnBox blue3Bg heightBtn_four" style="flex:1;">
                            <i class="el-icon-tickets btnIcon"></i>
                            <div class="btnRight">
                                <p class="textLine"><span class="normalFont bold">{{numAll.totalInvite}}</span>
                                    <span class="smallFont">人</span> </p>
                                <p class="textLine smallFont">累计报名数</p>
                            </div>
                        </div>

                    </div>
                    <div style="display: flex;">
                        <div class="btnBox orangeBg heightBtn_four" style="flex:1;">
                            <i class="el-icon-tickets btnIcon"></i>
                            <div class="btnRight">
                                <p class="textLine"><span class="normalFont bold">{{numAll.cartQuantity}}</span>
                                    <span class="smallFont">件</span> </p>
                                <p class="textLine smallFont">累计加购总件数</p>
                            </div>
                        </div>

                    </div>

                </div>
            </el-col>
            <!--第3块-->
            <el-col :span="5">
                <div class="grid-content ">
                    <div style="display: flex;margin-bottom:15px;">
                        <div class="btnBox  heightBtn_half" style="flex:1;">
                            <i class="el-icon-tickets btnIcon biggestFont blue"></i>
                            <div class="btnRight">
                                <p class="textLine blue"> <span class="biggestFont bold">{{numAll.todayInvite}}</span>
                                    <span class="normalFont">人</span> </p>
                                <p class="textLine normalFont darkBlue bold">今日报名数</p>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <div class="btnBox  heightBtn_half" style="flex:1;">
                            <i class="el-icon-tickets btnIcon biggestFont blue"></i>
                            <div class="btnRight">
                                <p class="textLine blue"> <span class="biggestFont bold">{{numAll.todayAmount}}</span>
                                    <span class="normalFont">元</span> </p>
                                <p class="textLine normalFont darkBlue bold">今日成交总金额</p>
                            </div>
                        </div>
                    </div>

                </div>
            </el-col>
            <!--第4块-->
            <el-col :span="5">
                <div class="grid-content ">
                    <div style="display: flex;margin-bottom:15px;">
                        <div class="btnBox  heightBtn_half" style="flex:1;">
                            <i class="el-icon-tickets btnIcon biggestFont blue"></i>
                            <div class="btnRight">
                                <p class="textLine blue"> <span class="biggestFont bold">{{numAll.todayQuantity}}</span>
                                    <span class="normalFont">件</span> </p>
                                <p class="textLine normalFont darkBlue bold">今日成交总件数</p>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <div class="btnBox  heightBtn_half" style="flex:1;">
                            <i class="el-icon-tickets btnIcon biggestFont blue"></i>
                            <div class="btnRight">
                                <p class="textLine blue"> <span class="biggestFont bold">{{numAll.todayOrder}}</span>
                                    <span class="normalFont">笔</span> </p>
                                <p class="textLine normalFont darkBlue bold">今日下单量</p>
                            </div>
                        </div>
                    </div>

                </div>
            </el-col>
        </el-row>
        <!--第二行-->
        <el-row :gutter="10">
            <el-col :span="4">
                <div class="grid-content ">
                    <div class="panelTitle">
                        选择榜单
                    </div>
                    <div class="panelLists">
                        <ul>
                            <li v-for="(list,index) in rankingWord" @click="getChart(list.value)" :class="{activeRankTitle:currentKey==list.value}">{{list.text}}>></li>
                        </ul>
                    </div>
                </div>
            </el-col>
            <el-col :span="20">
                <div class="grid-content echartBox">
                    <div id="echartBox" style="width:90%;height: 353px;"></div>
                </div>
            </el-col>
        </el-row>
        <!-- 第三行 -->
        <div class="basicInfoBox">
            <el-row >
                <el-col :span="24">
                    <div class="flexItem">
                        <span class="label">主办公司</span>
                        <span class="text">{{basicInfo.companyName}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="24">
                     <div class="flexItem">
                        <span class="label">联系人手机号码</span>
                        <span class="text">{{basicInfo.userPhone}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="24">
                     <div class="flexItem">
                        <span class="label">联系人姓名</span>
                        <span class="text">{{basicInfo.userName}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="24">
                     <div class="flexItem">
                        <span class="label">活动名称</span>
                        <span class="text">{{basicInfo.conferenceName}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="24">
                     <div class="flexItem">
                        <span class="label">活动主题</span>
                        <span class="text">{{basicInfo.conferenceSubject}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="24">
                     <div class="flexItem">
                        <span class="label">活动介绍</span>
                        <span class="text">{{basicInfo.conferenceIntro}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="12">
                     <div class="flexItem">
                        <span class="label">活动起止时间</span>
                        <span class="text">{{basicInfo.hdTimeSpan}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="12">
                     <div class="flexItem">
                        <span class="label">发布会起止时间</span>
                        <span class="text">{{basicInfo.fbhTimeSpan}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="12">
                     <div class="flexItem">
                        <span class="label">邀请起止时间</span>
                        <span class="text">{{basicInfo.yqTimespan}}</span>
                    </div>
                    
                </el-col>
                 <el-col :span="12">
                      <div class="flexItem">
                         <span class="label">受邀报名起止时间</span>
                         <span class="text">{{basicInfo.sybmTimeSpan}}</span>
                     </div>
                    
                </el-col>
                <el-col :span="12">
                     <div class="flexItem">
                        <span class="label">入场起止时间</span>
                        <span class="text">{{basicInfo.rcTimeSpan}}</span>
                    </div>
                    
                </el-col>
                <el-col :span="12">
                     <div class="flexItem">
                         <span class="label">客户可查看线上展品起止时间</span>
                        <span class="text">{{basicInfo.kckxszpTimeSpan}}</span>
                    </div>
                   
                </el-col>
                <el-col :span="12">
                     <div class="flexItem">
                        <span class="label">允许客户下单起止时间</span>
                        <span class="text">{{basicInfo.yxkhxdTimeSpan}}</span>
                    </div>
                    
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>
    import echarts from 'echarts'
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxPost,
        api
    } from '@/common/request.js'
    export default {
        name: 'Dashboard',
        data() {
            return {
                conferenceId: '',
                basicInfo:{
                    conferenceName:'--', 
                    conferenceSubject :'--', 
                    conferenceIntro :'--', 
                    hdTimeSpan :'--', 
                    fbhTimeSpan :'--', 
                    yqTimespan :'--', 
                    sybmTimeSpan :'--', 
                    rcTimeSpan :'--', 
                    kckxszpTimeSpan:'--',  
                    yxkhxdTimeSpan :'--', 
                    companyName :'--', 
                    userName :'--', 
                    userPhone :'--', 
                    phone :'--', 
                    adminSubmitTime :'--', 
                    userType :'--', 
                    authResult :'--', 
                    hdshzt:'--', 
                },
                currentKey: "", //图表排行榜当前选择的
                rankingWord: [{
                        text: '累计销售金额排行',
                        value: 'cumulativeSalesAmountRankingList'
                    },
                    {
                        text: '累计销售数量排行',
                        value: 'cumulativeSalesQuantityRankingList'
                    },
                    {
                        text: '累计加购数量排行',
                        value: 'cumulativePurchaseQuantityRankingList'
                    },
                    {
                        text: '累计浏览数量排行',
                        value: 'cumulativeNumberOfViewsList'
                    },
                    {
                        text: '累计收藏数量排行',
                        value: 'cumulativeCollectionQuantityRankingList'
                    },
                    {
                        text: '邀请排行榜',
                        value: 'inviteLeaderboardQueryList'
                    },
                ],
                charts: '',
                unitName: '',
                numAll: {
                    totalAmount: '-',
                    totalQuantity: '-',
                    totalOrder: '-',
                    orderAmount: '-',
                    orderQuantity: '-',
                    totalInvite: '-',
                    cartQuantity: '-',
                    todayInvite: '-',
                    todayAmount: '-',
                    todayQuantity: '-',
                    todayOrder: '-'
                },
                // //排行榜字典对应
                // listsNameWords: {
                //     cumulativeSalesAmountRankingList: "累计销售金额排行查询",
                //     cumulativePurchaseQuantityRankingList: "累计加购数量排行",
                //     cumulativeSalesQuantityRankingList: "累计销售数量排行",
                //     cumulativeNumberOfViewsList: "累计浏览数量排行",
                //     cumulativeCollectionQuantityRankingList: "累计收藏数量排行",
                //     inviteLeaderboardQueryList: "邀请排行榜"
                // },
                //排行榜数据
                rankingListsAll: {},
                //柱状图配置

                yData: ['巴西1', '印尼', '美国', '印度', '中国', '世界人口(万)'],
                optionColor: ['#5AB6DF', '#5AB6DF', '#5AB6DF', '#5AB6DF', '#5AB6DF', '#5A92DF', '#5B6ADF', '#8C5ADF', ],
                optionTitle: '世界人口总量',
                optionData: [18203, 23489, 29034, 104970, 131744, 630230],
            }
        }, //data end
        watch: {
            '$route': {
                immediate: true,
                handler: function(to, from) {
                    console.log("intro里的mounted刷新了")
                    let _this = this
                    let key = _this.rankingWord[0].value
                    _this.getParams()
                    _this.getDetail().then(function(value) {
                         _this.getChart(_this.rankingWord[0].value)
                    });

                }
            }
        },
        computed: {},
        methods: {
            getParams() {
                // let url = window.location.href
                // let index = url.search("=")
                // this.conferenceId = url.slice(index + 1)
                // console.log(this.conferenceId)
                this.conferenceId = this.$route.params.conferenceId
            },
            getDetail() {
                let _this = this
                var p = new Promise(function(resolve, reject) {
                    let arg = {
                        conferenceId: _this.conferenceId,
                        userId: 1
                    }
                    //获取图表中的
                    ajaxPost('/admin/conferenceProfile', arg).then(function(res) {
                        console.log('detail执行结束22222')
                        if (res.errorCode == 200) {
                            _this.numAll = {
                                totalAmount: res.data.totalAmount,
                                totalQuantity: res.data.totalQuantity,
                                totalOrder: res.data.totalOrder,
                                orderAmount: res.data.orderAmount,
                                orderQuantity: res.data.orderQuantity,
                                totalInvite: res.data.totalInvite,
                                cartQuantity: res.data.cartQuantity,
                                todayInvite: res.data.todayInvite,
                                todayAmount: res.data.todayAmount,
                                todayQuantity: res.data.todayQuantity,
                                todayOrder: res.data.todayOrder
                            }
                            _this.rankingListsAll = {
                                cumulativeCollectionQuantityRankingList: res.data.cumulativeCollectionQuantityRankingList
                                    .reverse(),
                                cumulativeNumberOfViewsList: res.data.cumulativeNumberOfViewsList.reverse(),
                                cumulativePurchaseQuantityRankingList: res.data.cumulativePurchaseQuantityRankingList
                                    .reverse(),
                                cumulativeSalesAmountRankingList: res.data.cumulativeSalesAmountRankingList.reverse(),
                                cumulativeSalesQuantityRankingList: res.data.cumulativeSalesQuantityRankingList
                                    .reverse(),
                                inviteLeaderboardQueryList: res.data.inviteLeaderboardQueryList.reverse(),
                            }
                            resolve("success");
                        }
                         
                    }, function(res) {
                    
                    })
                    //获取最下面一块的活动详情
                     ajaxPost('/admin/getconferenceReviewDetail', arg).then(function(res) {
                        if(res.data){
                             _this.basicInfo.companyName =res.data.companyName
                            _this.basicInfo.userName =res.data.userName
                            _this.basicInfo.userPhone =res.data.userPhone
                            _this.basicInfo.phone =res.data.phone
                            _this.basicInfo.adminSubmitTime =res.data.adminSubmitTime
                            _this.basicInfo.userType =res.data.userType
                            _this.basicInfo.authResult =res.data.authResult
                        }
                        
                    }, function(res) {
                       
                    })
                    ajaxPost('/admin/getconferenceinfo', arg).then(function(res) {
                        if(res.data){
                             _this.basicInfo.conferenceName=res.data.conference_name
                             _this.basicInfo.conferenceSubject =res.data.conference_subject
                             _this.basicInfo.conferenceIntro =res.data.conference_intro
                             _this.basicInfo.hdTimeSpan =res.data.conference_global_start_time&&res.data.conference_global_end_time ? res.data.conference_global_start_time+' 至 '+res.data.conference_global_end_time :'-'
                            _this.basicInfo.fbhTimeSpan = res.data.conference_start_time&&res.data.conference_end_time ? res.data.conference_start_time+' 至 '+res.data.conference_end_time:'-'
                            _this.basicInfo.yqTimespan =res.data.conference_invite_start_time&&res.data.conference_invite_end_time ? res.data.conference_invite_start_time+' 至 '+res.data.conference_invite_end_time:'-'
                            _this.basicInfo.sybmTimeSpan =res.data.conference_register_start_time&&res.data.conference_register_end_time ? res.data.conference_register_start_time+' 至 '+res.data.conference_register_end_time:'-'
                            _this.basicInfo.rcTimeSpan =res.data.conference_checkin_start_time&&res.data.conference_checkin_end_time ? res.data.conference_checkin_start_time+' 至 '+res.data.conference_checkin_end_time:'-'
                            _this.basicInfo.kckxszpTimeSpan =res.data.conference_item_start_time&&res.data.conference_item_end_time ? res.data.conference_item_start_time+' 至  '+res.data.conference_item_end_time:'-'
                            _this.basicInfo.yxkhxdTimeSpan =res.data.conference_ordering_start_time&&res.data.conference_ordering_end_time ? res.data.conference_ordering_start_time+' 至  '+res.data.conference_ordering_end_time:'-'
                            _this.basicInfo.hdshzt=res.data.conference_state
                        }
                        
                    }, function(res) {
                       
                    })
                   
                });
                return p
                
            },
            drawPie(id) {
                let yData = this.yData //坐标汉字
                let colorList = this.optionColor
                let title = this.optionTitle
                let optionData = this.optionData //数据
                let unitName = this.unitName
                // console.log(yData,'yData')
                // console.log(optionData,'optionData')
                this.charts = echarts.init(document.getElementById(id))
                this.charts.setOption({
                    title: {
                        text: title,
                        textStyle: {
                            color: "#6A89BE",
                            fontWeight: "normal"
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        axisLine: {
                            show: false

                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                        }
                    },
                    yAxis: {
                        data: yData,
                        axisLine: {
                            show: false

                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }


                    },
                    series: [{
                        //							name: '2011年',
                        type: 'bar',
                        barWidth: 17,
                        data: optionData,
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    return colorList[params.dataIndex]
                                },
                                label: {
                                    show: true,
                                    position: 'right',
                                    formatter: '{c}' + unitName
                                }
                            }
                        },
                    }]
                })
            },
            getChart(key) {
                console.log('开始执行getCHart333333333')
                let _this = this
                _this.currentKey = key
                _this.optionTitle = utils.findTextFromValue(_this.rankingWord, key)
                let currentRankingList = _this.rankingListsAll[key]
                _this.yData = []
                _this.optionData = []
                if (key == 'cumulativeCollectionQuantityRankingList') {
                    _this.unitName = "次"
                    currentRankingList.forEach(function(item, index) {
                        _this.yData.push(item.itemName + item.colorName + item.styleNumber)
                        _this.optionData.push(item.collectCount)
                    })
                }
                if (key == 'cumulativeNumberOfViewsList') {
                    _this.unitName = "次"
                    currentRankingList.forEach(function(item, index) {
                        _this.yData.push(item.itemName + item.colorName + item.styleNumber)
                        _this.optionData.push(item.pvCount)
                    })
                }
                if (key == 'cumulativePurchaseQuantityRankingList') {
                    _this.unitName = "次"
                    currentRankingList.forEach(function(item, index) {
                        _this.yData.push(item.itemName + item.colorName + item.styleNumber)
                        _this.optionData.push(item.cartCount)
                    })
                }
                if (key == 'cumulativeSalesAmountRankingList') {
                    _this.unitName = "元"
                    currentRankingList.forEach(function(item, index) {
                        _this.yData.push(item.itemName + item.colorName + item.styleNumber)
                        _this.optionData.push(item.checkoutAmount)
                    })
                }
                if (key == 'cumulativeSalesQuantityRankingList') {
                    _this.unitName = "件"
                    currentRankingList.forEach(function(item, index) {
                        _this.yData.push(item.itemName + item.colorName + item.styleNumber)
                        _this.optionData.push(item.checkoutCount)
                    })
                }
                if (key == 'inviteLeaderboardQueryList') {
                    _this.unitName = "人"
                    currentRankingList.forEach(function(item, index) {
                        _this.yData.push(item.userRealName + item.userId)
                        _this.optionData.push(item.inviteNum)
                    })
                }
                this.drawPie('echartBox')
            },
        }, //methods end
        components: {},
        mounted() {}
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    * {
        // outline: 1px solid blue;
    }

    .introListWrap11 {
        padding: 10px;

        .panelLists li.activeRankTitle {
            color: #5AB6DF
        }

        .dashboard-container {
            padding: 0px 15px;
            height: 80%
        }

        .el-row {
            margin-bottom: 10px;
        }

        .basicInfoBox {
            background: #fff;
            padding: 10px;
            margin-bottom: 50px;
            .flexItem{
                display: flex; padding:4px 0;
                .label {
                    color: #aaa;
                    font-weight: bold;
                    display: inline-block;
                    width: 190px;
                }
                .text{color:#000;flex:1;}
            }
            
        }

        .grid-content.white {
            background: #fff;
            padding: 10px 30px;
        }

        /*按钮样式*/

        .btnBox {
            display: flex;
            border-radius: 2px;
            box-shadow: 0px 5px 8px #D9ECFF;
            /*height: 300px;*/
        }

        .btnIcon {
            padding-left: 8%;
            display: flex;
            align-items: center;
            text-align: right;
        }

        .btnRight {
            flex: 3;
            text-align: center;
            margin-left: -20px;
        }

        .btnRight .textLine {
            padding: 3px 0;
        }

        .white {
            color: #fff;
        }

        .blue {
            color: #698ABC
        }

        .darkBlue {
            color: #9D9D9D
        }

        .smallFont {
            font-size: 12px;
        }

        .normalFont {
            font-size: 15px;
        }

        .biggestFont {
            font-size: 40px;
        }

        .blue1Bg {
            background: #6A8ABD;
        }

        .blue2Bg {
            background: #5AB6DF;
        }

        .blue3Bg {
            background: #4ACACB;
        }

        .orangeBg {
            background: #FB8675;
        }

        .heightBtn {
            height: 302px
        }

        .heightBtn_half {
            height: 153px;
            background: #fff;
        }

        .heightBtn_four {
            height: 68px;
        }

        .heightBtn_half .btnRight {
            padding-top: 40px;
        }

        .heightBtn_four .btnRight {
            padding-top: 12px;
        }

        .bold {
            font-weight: bold;
        }

        .firstBlock p {
            padding: 10px 0;
        }

        /*第二行左边*/

        .panelTitle {
            font-size: 17px;
            padding: 10px 15px;
            background: #fff;
            margin-bottom: 5px;
            ;
        }

        .panelLists {
            padding: 10px;
            background: #fff;
            height: 320px;
        }

        .panelLists li {
            padding: 8px 0;
            color: #696969;
            font-size: 14px;
        }

        .panelLists li:hover {
            color: #5AB6DF;
            cursor: pointer;
        }

        .echartBox {
            background: #fff;
            height: 367px;
            padding: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/intro.vue